import { Platform, createUseStyles } from 'core/src';
import React, { memo } from 'react';
import { Button, Spacing, Typography } from 'components/src';
import { ScrollView, View } from 'react-native';
import Fontisto from 'react-native-vector-icons/Fontisto';
import AntDesign from 'react-native-vector-icons/AntDesign';

const FontistoX = Fontisto as unknown as React.ComponentType<any>;
const AntDesignX = AntDesign as unknown as React.ComponentType<any>;

interface Props {
  messages?: any;
  onClose?: any;
  onClick?: any;
  isChannelAdmin?: any;
  type?: any;
}

const Pin = memo<Props>(
  ({ messages, onClose, onClick, isChannelAdmin, type }) => {
    const { styles, colors, theme } = useStyle();

    const sortedMessages = messages.sort((a: any, b: any) => {
      return (
        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      );
    });

    return (
      <>
        <View style={styles.pinnedMessagesBox}>
          <Spacing horizontal={3} />
          <FontistoX
            name="pinboard"
            size={Platform.isDesktop ? 30 : 15}
            color={theme === 'white' ? 'black' : '#fff'}
          />

          <ScrollView
            scrollEnabled={true}
            horizontal
            contentContainerStyle={styles.contentContainer}
            showsHorizontalScrollIndicator={false}
          >
            {sortedMessages?.map((item: any) => (
              <View style={styles.pinBox}>
                <Button
                  onClick={() => {
                    onClick(item.id);
                  }}
                >
                  <Typography
                    text={
                      item?.content
                        ? Platform.isDesktop
                          ? item.content?.substring(0, 55) + '...'
                          : item.content?.substring(0, 10) + '...'
                        : Platform.isDesktop
                          ? item.text?.substring(0, 55) + '...'
                          : item.text?.substring(0, 10) + '...'
                    }
                    row={1}
                    classes={
                      Platform.isDesktop
                        ? styles.messageDesk
                        : styles.messagePwa
                    }
                    color={colors.white}
                    size={Platform.isDesktop ? 20 : 15}
                  />
                </Button>
                {!isChannelAdmin && type === 'channel' ? null : (
                  <Button onClick={() => onClose(item.id)}>
                    <AntDesignX
                      name="close"
                      size={Platform.isDesktop ? 18 : 14}
                      color={colors.white}
                      style={{ padding: 3, marginRight: 7 }}
                    />
                  </Button>
                )}
              </View>
            ))}
          </ScrollView>
        </View>
      </>
    );
  },
);

const useStyle = createUseStyles(({ colors }) => ({
  container: {
    flex: 1,
  },
  messageCard: {
    overflow: 'scroll',
    flexDirection: 'row',
    alignItems: 'center',
  },
  pinnedMessagesBox: {
    flexDirection: 'row',
    alignItems: 'center',
    zIndex: 100,
    backgroundColor: colors.color03,
    shadowColor: '#000', // Shadow color
    shadowOffset: { width: 0, height: 2 }, // Offset for shadow
    shadowOpacity: 0.25, // Shadow opacity
    shadowRadius: 3.84, // Blur radius for shadow
    // Shadow for Android
    elevation: 5,
  },

  contentContainer: {
    paddingHorizontal: 10,
    height: Platform.isDesktop ? 40 : 30,
  },
  messagePwa: {
    padding: 3,
    flexWrap: 'wrap',
  },
  messageDesk: {
    padding: 10,
    flexWrap: 'wrap',
  },
  pinBox: {
    flexDirection: 'row',
    borderRadius: 50,
    alignItems: 'center',
    margin: 3,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    backgroundColor: colors.secondBlue,
  },
  pinPwa: {
    color: '#fff',
    fontSize: 18,
    padding: 4,
  },
  pinDesk: {
    color: '#fff',
    fontSize: 20,
    padding: 4,
  },
}));

export { Pin };
